<div class="chip-container">
  <div style="position: relative">
    <img
      src="{{defaultIcon}}"
      (click)="changeOperator()"
      (dblclick)="toggleOperator(defaultIcon)"
    />
    <div *ngIf="showMenuItem" class="bordered-container">
      <div
        class="icons-container"
        *ngFor="let item of operatorItems"
        [ngClass]="defaultIcon === item.icon ? 'activateIcon' : '' "
      >
        <img src="{{item.icon}}" (click)="selectIcon(item)" />
      </div>
    </div>
  </div>
  <div class="key">{{ keyword }}:</div>
  <div class="value" [attr.contenteditable]="editable">{{ operands }}</div>

  <button mat-button class="btn" *ngIf="!readonly">
    <mat-icon class="close" (click)="close()">close</mat-icon>
  </button>
</div>
